import { render } from "./MultipleChoiceTextQuestion.vue?vue&type=template&id=a5ef42a2"
import script from "./MultipleChoiceTextQuestion.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceTextQuestion.vue?vue&type=script&lang=js"

import "./MultipleChoiceTextQuestion.vue?vue&type=style&index=0&id=a5ef42a2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__